import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import MissionStatement from './components/MissionStatement';
import CareerTimeline from './components/CareerTimeline';
import EducationBackground from './components/EducationBackground';
import PersonalInterests from './components/PersonalInterests';
import CallToAction from './components/CallToAction';

const About = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet>
          <title>About Mustan Aliev - Full-Stack Engineer & Open Source Advocate | Mustan-Dev</title>
          <meta 
            name="description" 
            content="Discover Mustan Aliev's journey as a full-stack engineer, open source contributor, and creator of developer tools. Explore my technical philosophy, career milestones, education, and personal interests that drive innovation in web and AI development." 
          />
          <meta name="keywords" content="Mustan Aliev, Full-Stack Engineer, Open Source, Software Developer, Web Developer, React, Node.js, Career Timeline, Technical Philosophy, Developer Story, GitHub" />
          <meta property="og:title" content="About Mustan Aliev - Full-Stack Engineer & Open Source Advocate" />
          <meta property="og:description" content="Full-stack engineer and open source contributor building impactful software for developers. 8+ years of experience, 150+ projects delivered, and a commitment to innovation." />
          <meta property="og:type" content="profile" />
          <meta property="og:url" content="https://mustan-dev.web.app/about" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="About Mustan Aliev - Full-Stack Engineer" />
          <meta name="twitter:description" content="Learn about my journey from open source contributor to senior engineer, my technical philosophy, and what drives my passion for creating developer-focused solutions." />
          <link rel="canonical" href="https://mustan-dev.web.app/about" />
      </Helmet>

      <div className="min-h-screen bg-background">
        <main className="pt-16">
          <HeroSection />
          <MissionStatement />
          <CareerTimeline />
          <EducationBackground />
          <PersonalInterests />
          <CallToAction />
        </main>
      </div>
    </>
  );
};

export default About;
